import { makeStyles } from "@material-ui/styles";
import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  rootTabs: {
    justifyContent: "center"
  },
  scroller: {
    flexGrow: "0"
  },

  root: {
    flexGrow: 1,
    width: "100%",
   
  },
  textBanner:{
    border: "1px solid black",
    background: "#494DF4",
    color: "#ffffff",
    margin: "4px 12px 4px 12px"
  },
  tab1: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      width: "100%"
    }
  },
    // root: {
    //     transform: 'translateZ(0px)',
    //     flexGrow: 1,
    // },
    navBackground: {
        background: 'linear-gradient(134.89deg, #494DF4 24.95%, #9FBEAF 75.05%)',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
        height:'73px',
      
    },
    navTabs:{
      background:'#E5E5E5',
      color:theme.palette.text.primary,
    },
    
    dashWidth:{
        //marginLeft:"4px",
        width: "100%",
    },
    cstmWidthth: {
        width: "95%",
    },
    selectFontDash: {
        fontSize: "0.875rem",
    },
    cstmWidth: {
        display: "grid",
        height: "99%",
        background: theme.palette.background.paper,
        width: "fit-content",
        float: "right",
    },
    parentBackground:{
      background: theme.palette.background.paper,
    },
    brandLogoTitle: {
      fontFamily: 'Source Sans Pro',
      fontStyle: 'normal',
      fontWeight:600,
      textAlign: 'center',
      letterSpacint:'0em',
      color: '#FFFFFF',
      margin:'auto',
      width:'100%',
      height:'73px',
      lineHeight:'73px'
    
    },
    cstmAdj: {
        paddingTop: "9px",
        marginTop: "5px",
        marginRight: "4px",
    },
    speedDial: {
      position: 'fixed',
      bottom: theme.spacing(2),
          right: theme.spacing(16),
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
          bottom: theme.spacing(2),
          right: theme.spacing(8),
      },
      '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
          top: theme.spacing(3),
          left: theme.spacing(3),
      },
    },
    tabName: {
      whiteSpace: `nowrap`,
      overflow: `hidden`,
      textOverflow: `ellipsis`,
      fontWeight:"normal"
    },
    // tabButton: {
    //   color: theme.palette.text.primary,
    // },
    settingBtn:{
      // minWidth:"42px",
        '&:hover':{
            backgroundColor:'none !important'
        }
    },
    buttonCustom:{
      color:"#FFFFFF !Important",
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.overlayBg.background,
    },
    userSpeedDial: {
      position: 'fixed',
      bottom: theme.spacing(2),
          right: theme.spacing(8),
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
          bottom: theme.spacing(2),
          right: theme.spacing(8),
      },
      '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
          top: theme.spacing(3),
          left: theme.spacing(3),
      },
    },

}));


export const getMuiTheme = (theme) => {
  return createMuiTheme({
    ...theme,
    overrides: {
      MuiTabs:{
      root:{
        minHeight:'unset',
       
          "& .Mui-disabled": {
            // background: "initial",
            // color: "initial",
            display:'none !important'
        
        }
      
      }
      },
      MuiTab: {

      root: {
        // minHeight: "0px",
        // minWidth:0,
        padding: "10px 10px",


        height: '18px',
        color: '#333333 !important',
        fontFamily: "Source Sans Pro",
        fontSize: '12px',
        fontWeight: '600',
        letterSpacing: '0.86px',
        lineHeight: '18px',
        // eslint-disable-next-line no-useless-computed-key
        ["@media (min-width: 600px)"]: {
          minWidth: "0px",
        },
      },
      wrapper: {
        display: `inline-block`,
        textTransform: "capitalize"
      },
      textColorInherit: {
        "&$selected": {
          color: theme.primary,
          borderBottom: "3px solid " + theme.primary,
        },
      },
    },
    MuiButton:{
        root:{
            '&:hover':{
            backgroundColor:'none !important'
            },
           
        },
       
    },
    
    MuiPaper:{
        elevation1:{
            boxShadow:'none'
        }

    },
    MuiDialog:{
      paper:{
          borderTop: theme.palette.primary.main + ' solid 3px',
      }
    },
    MuiSpeedDialIcon:{
      root:{
        color:"#FFFFFF!Important",

      }
    }  
    },
  });
}
  
